'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { PopTip } from '~/components/Tooltip';
import { visuallyHidden } from '~/components/Utilities';
import type { ItineraryCardTrainTimesProps } from './ItineraryCard.types';
import styles from './ItineraryCardTrainTimes.module.css';
export function ItineraryCardTrainTimes(t0) {
  const $ = _c(45);
  const {
    date,
    arrivalDate,
    departureTime,
    arrivalTime,
    originStation,
    destinationStation,
    duration
  } = t0;
  const t = useTranslations("journey");
  let t1;
  if ($[0] !== arrivalDate || $[1] !== date) {
    t1 = arrivalDate ? <div className={styles.dateRow}><p className={styles.dateStart}>{date}</p><p className={styles.dateEnd}>{arrivalDate}</p></div> : <p className={styles.date}>{date}</p>;
    $[0] = arrivalDate;
    $[1] = date;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = departureTime ?? "\u2014";
  const t3 = arrivalTime ?? "\u2014";
  let t4;
  if ($[3] !== t || $[4] !== t2 || $[5] !== t3) {
    t4 = t("itinerary_depart_arrive", {
      departureTime: t2,
      arrivalTime: t3
    });
    $[3] = t;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <legend className={visuallyHidden}>{t4}</legend>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = departureTime ?? "\u2014";
  let t7;
  if ($[9] !== t6) {
    t7 = <span className={styles.time}>{t6}</span>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={styles.timeLine} aria-hidden="true" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = arrivalTime ?? "\u2014";
  let t10;
  if ($[12] !== t9) {
    t10 = <span className={styles.time}>{t9}</span>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5 || $[16] !== t7) {
    t11 = <fieldset className={styles.times}>{t5}{t7}{t8}{t10}</fieldset>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== originStation) {
    t12 = <span className={styles.stationTooltip}>{originStation}</span>;
    $[18] = originStation;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== originStation) {
    t13 = <span className={styles.stationLabel}>{originStation}</span>;
    $[20] = originStation;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== originStation || $[23] !== t12 || $[24] !== t13) {
    t14 = <span className={styles.station}><PopTip content={t12} ariaLabel={originStation}>{t13}</PopTip></span>;
    $[22] = originStation;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== duration) {
    t15 = <span className={styles.duration}>{duration}</span>;
    $[26] = duration;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = clsx(styles.station, styles.stationEnd);
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== destinationStation) {
    t17 = <span className={styles.stationTooltip}>{destinationStation}</span>;
    $[29] = destinationStation;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== destinationStation) {
    t18 = <span className={styles.stationLabel}>{destinationStation}</span>;
    $[31] = destinationStation;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== destinationStation || $[34] !== t17 || $[35] !== t18) {
    t19 = <span className={t16}><PopTip content={t17} ariaLabel={destinationStation}>{t18}</PopTip></span>;
    $[33] = destinationStation;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t19) {
    t20 = <div className={styles.stations}>{t14}{t15}{t19}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t1 || $[42] !== t11 || $[43] !== t20) {
    t21 = <div className={styles.container}>{t1}{t11}{t20}</div>;
    $[41] = t1;
    $[42] = t11;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
}